import React from 'react';

import copy from '../../content/copy';
import HomeTitle from '../components/home/title/HomeTitle';

const IndexPage = () => {
    const { siteTitle } = copy;
    const { roles } = copy.home;

    return (
        <div>
            <HomeTitle roles={roles} name={siteTitle} />
        </div>
    );
};

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.jsx